/* eslint-disable max-lines-per-function */
import React, { useContext, useEffect, useState } from 'react';
import { Form, Formik } from 'formik';
import { MultiSelect } from 'primereact/multiselect.js';
import { Button, CircularProgress } from '@material-ui/core';
import Swal from 'sweetalert2';
import mensalidadeService from '../../../services/mensalidades/mensalidadeService';
import EdicaoPrecoMensalidadeContext from '../context/EdicaoMensalidadeContext';
import { showMessageError } from '../../others/toastr';
import { decriptObjectOnLocalStorage } from '../../../modulos/cripotografia/criptoStorage';

export default function FormBonificacao() {
    const [bonificacao, setBonificacao] = useState();
    const [dadosBonificacao, setDadosBonificacao] = useState();
    const [bonificacaoSelecionada, setBonificacaoSelecionada] = useState();
    const [desativarBotaoBonifica, setDesativarBotaoBonifica] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const { lotePrecoMensalidadeContextState, setLotePrecoMensalidadeContextState } = useContext(EdicaoPrecoMensalidadeContext);

    useEffect(() => {
        (async () => {
            try {
                const responseBonificacao = await mensalidadeService.buscaBonificacaoMensalidades('?status=true');

                setBonificacao(responseBonificacao?.map(item => ({
                    label: item.descricao,
                    value: {
                        id: item.id,
                        label: item.descricao
                    }
                })));
            } catch (err) {
                console.error(err);
            }
        })();
    }, []);

    useEffect(() => {
        if (bonificacaoSelecionada && bonificacaoSelecionada.length) {
            setDadosBonificacao({
                status: true,
                idBonificacao: bonificacaoSelecionada[0].id
            });
        }
    }, [bonificacaoSelecionada]);

    const changeBonificacao = e => {
        if (e.value.length > 0) {
            setBonificacaoSelecionada([e.value[e.value.length - 1]]);
            setDesativarBotaoBonifica(false);
        }
    };

    const handleFormSubmit = async () => {
        setIsLoading(true);

        try {
            const planosCidadesAlteradas = lotePrecoMensalidadeContextState.planosSelecionados.map(item => ({
                plano: item.plano,
                uf: item.estado,
                cidade: item.cidade?.id
            }));

            const body = {
                planosCidadesAlteradas,
                bonificacao: dadosBonificacao,
                usuario: decriptObjectOnLocalStorage('IDuser')
            };

            const response =
                await mensalidadeService.vincularBonificacaoAoProduto(body);

            if (response.status === 202) {
                const abonoVinculadoSucesso = response.data.bonificadosSucesso.map(item => item.produto.plano);
                const abonoVinculadoFalha = response.data.bonificadosFalha.map(item => item.produto.plano);
                const bonificadosConflitoVigencia = response.data.bonificadosConflitoVigencia.map(item => item.produto.plano);

                let message = '';

                if (abonoVinculadoSucesso.length) {
                    message += `<strong>Operação realizada com sucesso!</strong><br>A bonificação foi aplicada aos seguintes planos: ${abonoVinculadoSucesso.join(', ')}.<br><br>`;
                }

                if (bonificadosConflitoVigencia.length) {
                    message += `<strong>Atenção:</strong><br>Os planos ${bonificadosConflitoVigencia.join(', ')} encontraram um conflito de datas de vigência com bonificações 
                        já existentes para a mesma localização.<br><br>Isso significa que não é possível aplicar a nova bonificação nas datas selecionadas porque já existem outras bonificações ativas no mesmo período e localização. Verifique as datas de vigência das bonificações existentes e ajuste a nova bonificação para evitar sobreposição.<br><br>
                    `;
                }

                if (abonoVinculadoFalha.length) {
                    message +=
                        `<strong>Atenção:</strong> Os seguintes Planos não foram encontrados na base de dados nesta(s) localidade(s): ${abonoVinculadoFalha.join(', ')}.<br><br>
                        Para prosseguir, é necessário primeiro cadastrá-los. Acesse a área de cadastro acima, inclua-os e, em seguida, tente adicionar a bonificação novamente.`;
                }

                const iconType = abonoVinculadoFalha.length > 0 || bonificadosConflitoVigencia.length > 0 ? 'warning' : 'success';

                Swal.fire({
                    title: 'Resultado da Operação',
                    html: message,
                    confirmButtonColor: 'green',
                    allowOutsideClick: false,
                    icon: iconType,
                    confirmButtonText: 'OK',
                    heightAuto: true
                });
            } else {
                showMessageError('', 'Não foi possível realizar cadastrar o abono. Por favor, tente novamente.');
            }

            setBonificacaoSelecionada([]);
            setDesativarBotaoBonifica(true);
            setLotePrecoMensalidadeContextState({
                ...lotePrecoMensalidadeContextState,
                limparEstadosTabela: true,
                planosSelecionados: []
            });
        } catch (error) {
            console.error(error);
            showMessageError('', 'Ocorreu um erro durante o processo. Por favor, tente novamente.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Formik
            initialValues={{
                plano: '',
                estado: '',
                cidade: null,
                bonificacao: {
                    status: false,
                    idBonificacao: null
                }
            }}

            onSubmit={handleFormSubmit}
            validateOnChange={true}
        >
            {() => (
                <Form
                    className="form-cadastro-edicao-planos"
                    style={{ marginTop: '20px' }}
                >
                    <div className="header-form-dados">
                        <div className="header-form-dados-title">
                            <h2>Bonificação</h2>
                            <p>
                                Escolha um tipo de bonificação para atribuir a um produto (plano) existente.
                            </p>
                            <div className="d-flex justify-content-start align-items-center">
                                <MultiSelect
                                    value={bonificacaoSelecionada}
                                    options={bonificacao}
                                    onChange={changeBonificacao}
                                    filter={true}
                                    filterPlaceholder="Procurar"
                                    placeholder="Adicionar Bonificação"
                                    style={{
                                        width: '32.5%',
                                        marginRight: '15px'
                                    }}
                                />
                                <Button
                                    variant="contained"
                                    color="primary"
                                    style={{
                                        marginBottom: '2.5vh',
                                        marginLeft: '1vw',
                                        alignItems: 'center'
                                    }}
                                    type='submit'
                                    disabled={desativarBotaoBonifica || isLoading}
                                >
                                    {isLoading && <CircularProgress size={24} style={{ marginRight: '8px' }} />}
                                    {isLoading ? 'Cadastrando Bonificações, Aguarde...' : 'Aplicar Bonificação'}
                                </Button>
                            </div>
                        </div>
                    </div>
                </Form>
            )}
        </Formik>
    );
}
